import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import ServiceRestServices from '../../services/service-rest.service';
import Config from '../../utils/config.service';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'booking-mental-check-unavailable',
	templateUrl: './booking-mental-check-unavailable.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export default class BookingMentalCheckUnavailableView implements OnInit {
	private session: Session = inject(Session);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private config: Config = inject(Config);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('home').then(() => {
			this.onResolve();
		});
	}
	
	onResolve() {
		this.vm.startTimeInHours = 0;
		this.vm.endTimeInHours = 23;
		this.vm.user = this.session.getSession().user;
		this.vm.isInitialized = true;
		this.checkMentalHealthServiceAvailable();
	}
	
	checkMentalHealthServiceAvailable() {
		var params: any = {
			origin: this.vm.user.origin
		};
		this.serviceRestServices.getMentalHealthServiceAvailability(params,
			(serviceAvailability) => {
				this.vm.startTimeInHours = serviceAvailability['startTimeInHours'];
				this.vm.endTimeInHours = serviceAvailability['endTimeInHours'];
				this.vm.weekendStartTimeInHours = serviceAvailability['weekendStartTimeInHours'];
				this.vm.weekendEndTimeInHours = serviceAvailability['weekendEndTimeInHours'];
				this.vm.isOutOfHoursMode = this.config.isOnDemandServiceUnavailable(serviceAvailability);
			}
		);
	}
	
}